import { useEffect, useState } from 'react'

import Api from 'services/api'

const useDealerFeatures = (dealerId) => {
  const [features, setFeatures] = useState<Array<string> | null>(null)
  const [isFeaturesLoaded, setIsFeaturesLoaded] = useState(false)

  useEffect(() => {
    Api.FeatureCodes.dealerFeatures(dealerId)
      .then(res => {
        setFeatures(res.features)
      }).catch(() => {
        setFeatures(null)
      })
      .finally(() => setIsFeaturesLoaded(true))
  }, [dealerId])

  return { features, isFeaturesLoaded }
}

export default useDealerFeatures
